/* eslint-disable import/prefer-default-export */

export { default as ItemActionsBar } from './ItemActionsBarConnector';
